import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import paths from 'routes/paths';
import { login, item } from '../../lib/api/user';
import { useAppContext } from '../../providers/AppProvider';

const forgotPasswordPaths = {
  simple: paths.simpleForgotPassword,
  split: paths.splitForgotPassword,
  card: paths.cardForgotPassword
};

const getDefaultRouteByRole = roleTypeId => {
  if (['staff', 'judge', 'supervisor'].includes(roleTypeId)) {
    return paths.activeMatches;
  }

  return '/';
};

const LoginForm = ({ hasLabel = false, layout = 'simple' }) => {
  const navigate = useNavigate();
  const { setUserApp } = useAppContext();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const isValidEmail = email => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    };

    const newErrors = {
      email: !formData.email.trim() || !isValidEmail(formData.email),
      password: !formData.password.trim()
    };

    setErrors(newErrors);
    return !Object.values(newErrors).some(Boolean);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const response = await login(formData);
      localStorage.setItem('token', response.token);
      if (response.token) {
        const decoded = jwtDecode(response.token);
        localStorage.setItem('entities_guide', decoded.entities_guide);
        const _user = await item({ user_guid: decoded.userId });
        const nextUser = _user[0];
        localStorage.setItem('user', JSON.stringify(nextUser));

        setUserApp(nextUser);
        navigate(getDefaultRouteByRole(nextUser?.role_type_id));
      }
    } catch (e) {
      console.error('Login error', e.status, e.body);
      if (e.error) {
        alert(
          'Doslo je do greske.\n' + (e.error?.[0]?.msg || 'Nepoznata greska')
        );
      }
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Email address' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Password' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto" />

        <Col xs="auto">
          <Link className="fs-10 mb-0" to={forgotPasswordPaths[layout]}>
            Forgot Password?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password}
        >
          Log in
        </Button>
      </Form.Group>
    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

export default LoginForm;
